import React, { useState, useEffect, useCallback, useRef } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  getActivePastOrder,
  deletePastOrder,
  getAllPastOrderDetailsList,
  getInvoiceBusinessUnitList,
  getInvoiceSupplierList,
} from "../../../service/PastOrder/PastOrderService";
import { getAllIndustryDetailslist } from "../../../service/BusinessUnit/BusinessUnitService";
import { format } from "date-fns";
import moment from "moment";
import { Button, Modal, Nav, Tooltip, OverlayTrigger } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Multiselect from "../Multiselect";
import ReactPaginate from "react-paginate";
import SpinnerComponent from "../../components/SpinnerComponent";
import instance from "../../../WebApi/WebApi";
import debounce from "lodash.debounce";
import { getAllCurrencylist } from "../../../service/Currency/CurrencyService";
import countryLocales from "../invoice/Locale";
import { useTranslation } from "react-i18next";

const Pastorder = () => {
  const { t } = useTranslation();
  const [logs, setLogs] = useState(false);
  const [activeTab, setActiveTab] = useState("link-1");
  const [isActive, setActive] = useState("false");
  const [currentPage, setCurrentPage] = useState(0);
  const [date, setDate] = useState(new Date());
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [finalStartDate, setFinalStartDate] = useState("");
  const [finalEndDate, setFinalEndDate] = useState("");
  const [search, setSearch] = useState("");
  const [pastOrderList, setAllPastOrderList] = useState([]);
  const [pagination, setPagination] = useState({});
  const [invoiceBusinessDataList, setAllInvoiceBusinessDataList] = useState([]);
  const [invoiceSupplierDataList, setAllInvoiceSupplierDataList] = useState([]);
  const [businessUnit, setBusinessUnit] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [pastOrderId, setDeletePastOrderId] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [showAnswer, setShowAnswer] = useState(false);
  const [showComment, setShowComment] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [orderStatus, setOrderStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [allLogs, setAllLogs] = useState();
  const [id, setId] = useState();
  const [currencyData, setCurrencyData] = useState([]);
  const PER_PAGE = 10;
  const abortControllerRef = useRef(null);

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  // const offset = currentPage * PER_PAGE;
  // const currentPageData = pastOrderList?.slice(offset, offset + PER_PAGE);

  // const pageCount = Math.ceil(pastOrderList?.length / PER_PAGE);

  const handleToggle = (id, isActive) => {
    getActivePastOrder("PastOrder", id, isActive ? false : true, (r) => {
      if (r.success === true) {
        getInvoiceDataList();
      } else {
        setIsLoading(false);
      }
    });
  };
  const handleCloseDelete = () => setShowDelete(false);
  const handleCloseAnswer = () => setShowAnswer(false);
  const handleCloseComment = () => setShowComment(false);
  const handleCloseLogs = () => setLogs(false);

  const getInvoiceDataList = useCallback(async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const result = await getAllPastOrderDetailsList();
      const response = result?.data;
      setAllPastOrderList(response?.data?.listPastOrder);
    } catch (error) {
      console.error("Error fetching invoice data:", error);
    } finally {
      setIsLoading(false);
    }
  }, [isLoading]);

  useEffect(() => {
    getInvoiceBusniessDataList();
    getInvoiceSupplierDataList();
    // getInvoiceDataList();
    getCurrencyDataList();
  }, []);

  async function getCurrencyDataList() {
    getAllCurrencylist().then(function (result) {
      const response = result?.data;

      const defaultCurrencyData = response?.data?.currencyList.filter(
        (item) => item.defaultCurrency
      );
      setCurrencyData(defaultCurrencyData);
      //  console.log("defaultCurrencyData", defaultCurrencyData);
    });
  }

  //list of business unit
  async function getInvoiceBusniessDataList() {
    getAllIndustryDetailslist().then(function (result) {
      const response = result?.data;
      setAllInvoiceBusinessDataList(response?.data);
    });
  }
  //list of suppliers
  async function getInvoiceSupplierDataList() {
    getInvoiceSupplierList().then(function (result) {
      const response = result?.data;
      setAllInvoiceSupplierDataList(response?.data?.SuppliersList);
    });
  }

  const onBusinessUnit = (e) => {
    // const ArrBus = e.target.value ? [e.target.value] : "";
    // businessUnit.push(e.target.value);
    // setBusinessUnit(businessUnit);
    // console.log("ArrBus a ", ArrBus);
    // console.log("ArrBus", e.target.value);
    if (e.target.value === "all") {
      setBusinessUnit([]);
      return;
    }
    setBusinessUnit([e.target.value]);

    // getAllPastOrderDetailsList(
    //   ArrBus,
    //   supplier,
    //   search,
    //   finalStartDate,
    //   finalEndDate,
    //   orderStatus
    // ).then(function (result) {
    //   const response = result?.data;
    //   setAllPastOrderList(response?.data?.listPastOrder);
    // });
  };

  const onSuppliers = (e) => {
    const ArrSup = e ? e : [];
    // console.log("ArrSup", ArrSup);
    // supplier.push(e);
    setSupplier(ArrSup);

    // getAllPastOrderDetailsList(
    //   businessUnit,
    //   ArrSup,
    //   search,
    //   finalStartDate,
    //   finalEndDate,
    //   orderStatus
    // ).then(function (result) {
    //   const response = result?.data;
    //   setAllPastOrderList(response?.data?.listPastOrder);
    // });
  };

  const onSearch = useCallback(
    debounce(async (data) => {
      try {
        const allData = {
          fromDate: finalStartDate || "",
          toDate: finalEndDate || "",
          businessUnitName: businessUnit
            ? [...new Set(businessUnit.map(Number))]
            : [],
          suppliersName: supplier ? supplier.flat() : [],
          orderStatus: orderStatus ? [orderStatus] : [],
        };

        const res = await instance.post(
          `/customer/past-order/list-past-order?searchKeyword=${data}`,
          allData
        );
        if (res?.data?.data?.listPastOrder) {
          console.log(res?.data?.data?.listPastOrder);
          setAllPastOrderList(res?.data?.data?.listPastOrder);
        } else {
          setAllPastOrderList([]);
        }
      } catch (err) {
        //  console.log(err);
      }
    }, 500),
    [search, finalStartDate, finalEndDate, businessUnit, supplier, orderStatus]
  );

  const handleSearchInput = (e) => {
    const data = e.target.value;
    setSearch(data);
    onSearch(data);
  };

  const addOneDayToDate = (date) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate());
    return newDate;
  };

  const onFromDate = (e) => {
    setStartDate(e);
    const fromDate = moment(e).format("DD-MM-YYYY");
    //  console.log(fromDate, "fromDate");
    setFinalStartDate(fromDate);
    // getAllPastOrderDetailsList(
    //   businessUnit,
    //   supplier,
    //   search,
    //   fromDate,
    //   finalEndDate,
    //   orderStatus
    // ).then(function (result) {
    //   const response = result?.data;
    //   setAllPastOrderList(response?.data?.listPastOrder);
    // });
  };

  const onToDate = (e) => {
    setEndDate(e);
    const toDate = moment(e).format("DD-MM-YYYY");
    setFinalEndDate(toDate);
    // getAllPastOrderDetailsList(
    //   businessUnit,
    //   supplier,
    //   search,
    //   finalStartDate,
    //   toDate,
    //   orderStatus
    // ).then(function (result) {
    //   const response = result?.data;
    //   setAllPastOrderList(response?.data?.listPastOrder);
    // });
  };
  const onChangeOrderStatus = (e) => {
    setOrderStatus(e.target.value);
    // getAllPastOrderDetailsList(
    //   businessUnit,
    //   supplier,
    //   search,
    //   finalStartDate,
    //   finalEndDate,
    //   e.target.value
    // ).then(function (result) {
    //   const response = result?.data;

    //   setAllPastOrderList(response?.data?.listPastOrder);
    // });
  };
  const getAnswer = (d) => {
    let count = 0;
    d?.SelectedPastOrderQualityControls?.map((data) => {
      if (data?.answer) {
        count = count + 1;
      }
    });
    return count;
  };
  const isAllAsnwer = (d) => {
    return d?.SelectedPastOrderQualityControls.filter(
      (item) => item.answer === "Yes"
    ).length === d?.SelectedPastOrderQualityControls.length
      ? { color: "green" }
      : { color: "red" };
  };

  const getComment = (d) => {
    let count = 0;
    d?.CommentsLogs?.map((data) => {
      if (data?.comments) {
        count = count + 1;
      }
    });
    return count;
  };

  const onDelete = (data) => {
    setDeletePastOrderId(data);
    setShowDelete(true);
  };

  const onYes = () => {
    deletePastOrder(pastOrderId, (res) => {
      if (res.success === true) {
        toast.success(res.message);
        setShowDelete(false);
        getInvoiceDataList();
      } else {
        toast.error(res.message);
      }
    });
  };

  const onNo = () => {
    setShowDelete(false);
  };

  const [anserIndex, setAnserIndex] = useState(null);
  const [commentIndex, setCommentIndex] = useState(null);
  const onAnswer = (e, index) => {
    e.preventDefault();
    setAnserIndex(index);
    setShowAnswer(true);
  };

  const onComment = (e, index) => {
    e.preventDefault();
    setCommentIndex(index);
    setShowComment(true);
  };

  const onLogs = (e, id) => {
    e.preventDefault();
    getAllLogs(id);
  };
  const getAllLogs = async (id) => {
    setId(id);
    const data = {
      pastOrderId: id,
    };
    try {
      const response = await instance.post(
        `/customer/past-order/get-past-order-logs`,
        data
      );
      //  console.log("response-->", response);
      if (response?.data?.success) {
        setAllLogs(response?.data?.data?.pastOrderDetails);
        setLogs(true);
        setIsLoading(false);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
      setIsLoading(false);
    }
  };

  const _RESET = (e) => {
    e.preventDefault();
    setSearch("");
    setBusinessUnit([]);
    setSupplier([]);
    setFinalStartDate("");
    setFinalEndDate("");
    setStartDate("");
    setEndDate("");
    setOrderStatus("");
    setSelectedOptions([]);
    // getAllPastOrderDetailsList("", [], [], "", "", "").then(function (result) {
    //   const response = result?.data;
    //   setAllPastOrderList(response?.data?.listPastOrder);
    // });
  };

  const handleSelect = async (eventKey) => {
    //  console.log("eventKey", eventKey);
    setIsLoading(true);

    const urlMap = {
      "link-1": "/customer/past-order/get-past-order-logs",
      "link-2": "/customer/past-order/get-past-order-comment-logs",
      "link-3": "/customer/past-order/get-past-order-order-logs",
      "link-4": "/customer/past-order/get-past-order-quantity-logs",
      "link-5": "/customer/past-order/get-past-order-business-logs",
      "link-6": "/customer/past-order/get-past-order-ghg-logs",
      "link-7": "/customer/past-order/get-past-order-delivery-logs",
    };
    const url = urlMap[eventKey];

    if (!url) {
      console.error("Invalid eventKey provided.");
      return;
    }

    const data = {
      pastOrderId: id,
    };

    try {
      const response = await instance.post(url, data);
      //  console.log("response", response);
      setAllLogs(response?.data?.data?.pastOrderDetails);

      setActiveTab(eventKey);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error in API call", error);
    }
  };

  const formatCurrency = (amount, currency = "USD") => {
    const selectedLocale = countryLocales.find(
      (item) => item.country === currency
    )?.code;

    return new Intl.NumberFormat(selectedLocale, {
      maximumFractionDigits: 2,
    }).format(amount);
  };

  useEffect(() => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      getAllPastOrderDetailsList(
        businessUnit,
        supplier,
        search,
        finalStartDate,
        finalEndDate,
        orderStatus,
        currentPage,
        controller.signal
      ).then(function (result) {
        const response = result?.data;
        setAllPastOrderList(response?.data?.listPastOrder);
        setPagination(response?.data?.pagination);
      });
    } catch (err) {
      if (err.name === "AbortError") {
        // Request was aborted, do nothing
      } else {
        // toast.error("Failed to fetch Products List");
      }
    } finally {
      setIsLoading(false);
    }
  }, [
    businessUnit,
    supplier,
    search,
    finalStartDate,
    finalEndDate,
    orderStatus,
    currentPage,
  ]);

  return (
    <div className="container-fluid">
      <div className="dbMain pastorder">
        <Leftpanel breadcm="Order" />
        <div className="dbRight">
          <Header
            link="/dashboard"
            breadcm=""
            title={t("orders")}
            description=""
          />
          <div className="commonBase">
            <div className="dbtableTop mb-3 poSrch">
              <div className="dbSearch">
                <input
                  type="search"
                  className="form-control"
                  placeholder={t("Search")}
                  onChange={handleSearchInput}
                  value={search}
                />
                <i className="fa-solid fa-magnifying-glass"></i>
              </div>
              <div className="dbtableSrchbg">
                <button className="commonButton" onClick={_RESET}>
                  {t("Reset")}
                </button>
              </div>
            </div>
            <div className="dbtableTop">
              <div className="dbtableSrchbg justify-content-between col-12">
                <div className="mx-2 my-2">
                  <div className="dateSelect">
                    <DatePicker
                      selectsStart
                      selected={startDate}
                      onChange={onFromDate}
                      placeholderText={t("From")}
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
                <div className="mx-2 my-2">
                  <div className="dateSelect">
                    <DatePicker
                      selectsEnd
                      selected={endDate}
                      onChange={onToDate}
                      endDate={endDate}
                      startDate={startDate}
                      minDate={startDate}
                      placeholderText={t("To")}
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
                <div className="mx-2 my-2">
                  <div>
                    <Multiselect
                      onSuppliers={onSuppliers}
                      options={invoiceSupplierDataList.map(
                        (item) => item.AccountingSupplierParty
                      )}
                      type={"Vendors"}
                      selectedOptions={selectedOptions}
                      setSelectedOptions={setSelectedOptions}
                    />
                  </div>
                </div>
                <div className="mx-2 my-2">
                  {/* <select
                    className="form-control mr-0"
                    onChange={onBusinessUnit}
                    placeholder={t("Select Business unit")}
                  >
                    <option selected={businessUnit === ""} value="">
                      {t("All Business unit")}
                    </option>
                    {invoiceBusinessDataList.map((d) => (
                      <option value={d?.id}>{d?.name}</option>
                    ))}
                  </select> */}
                  <select
                    className="form-control mr-0"
                    onChange={onBusinessUnit}
                    value={businessUnit}
                  >
                    <option value="" disabled hidden>
                      {t("Business unit")}
                    </option>
                    <option value="all">{t("All Business unit")}</option>
                    {invoiceBusinessDataList.map((d) => (
                      <option key={d?.id} value={d?.id}>
                        {d?.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="mx-2 my-2">
                  <select
                    className="form-control mr-0"
                    onChange={onChangeOrderStatus}
                  >
                    <option selected={businessUnit === ""} value="">
                      {t("Status")}
                    </option>
                    <option value="Created">{t("Created")}</option>
                    <option value="Received with issues">
                      {t("received_with_comments")}
                    </option>
                    <option value="Received">{t("Received")}</option>
                    <option value="Approved with issues">
                      {t("approved_with_comments")}
                    </option>
                    <option value="Approved">{t("Approved")}</option>
                    <option value="Rejected">{t("Rejected")}</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("orderId")}</th>
                    <th>{t("invoice_id")}</th>
                    <th>{t("business_units")}</th>
                    {/* <th>{t("orderDate")}</th> */}
                    <th>
                      {t("Date")}
                      <span className="bg-segment color-box me-1"></span>
                      <span className="bg-segment color-box me-1"></span>
                    </th>
                    <th>{t("vendor")}</th>
                    {/* <th>{t("registrations")}</th> */}
                    <th>{t("Total Amount")}</th>
                    <th>{t("GHG Key")}</th>
                    <th>{t("Order Status")}</th>
                    <th>{t("action")}</th>
                  </tr>
                </thead>
                {isLoading && <SpinnerComponent isLoading={isLoading} />}

                <tbody className="fw-500">
                  {pastOrderList?.map((d, index) => (
                    <tr className={d?.isActive ? null : "inactive"}>
                      <td data-label="Past Order ID">
                        <Link
                          to={`/pastorderdetail?id=${d?.id}&invoiceId=${d?.invoiceId}`}
                          style={{ color: "rgb(13, 110, 253)" }}
                        >
                          {d?.id}
                        </Link>
                      </td>
                      <td data-label="Invoice ID">
                        <Link
                          to={`/invoicedetails?id=${d?.orginalInvoiceId}`}
                          style={{ color: "rgb(13, 110, 253)" }}
                        >
                          {d?.Invoice?.invoice?.Invoice?.ID?._text}
                        </Link>
                      </td>
                      <td data-label="Department">
                        <Link
                          to={
                            d?.DepartmentId
                              ? `/businessunitdetl?id=${d?.BusinessUnit?.id}`
                              : "/pastorder"
                          }
                          style={{
                            color: d?.BusinessUnit?.name
                              ? "rgb(13, 110, 253)"
                              : "",
                          }}
                        >
                          {d?.BusinessUnit?.name || ""}
                        </Link>
                      </td>
                      <td data-label="Date of Generation">
                        <Link to={`javascript:void(0)`}>
                          {d?.deliveryDateTime ? (
                            <div className="color-segment">
                              <div title="Delivery Date">
                                {format(
                                  addOneDayToDate(d?.deliveryDateTime),
                                  "dd-MM-yyyy"
                                )}
                              </div>
                              <div title="Delivery Date">
                                {addOneDayToDate(
                                  d?.deliveryDateTime
                                ).toLocaleDateString("en-us", {
                                  weekday: "long",
                                })}
                              </div>
                            </div>
                          ) : d?.Invoice?.invoice?.Invoice?.IssueDate?._text ? (
                            <div title="Issue Date" className="color-commodity">
                              <div title="Issue Date">
                                {format(
                                  addOneDayToDate(
                                    d?.Invoice?.invoice?.Invoice?.IssueDate
                                      ?._text
                                  ),
                                  "MM-dd-yyyy"
                                )}
                              </div>
                              <div title="Issue Date">
                                {addOneDayToDate(
                                  d?.Invoice?.invoice?.Invoice?.IssueDate?._text
                                ).toLocaleDateString("en-us", {
                                  weekday: "long",
                                })}
                              </div>
                            </div>
                          ) : (
                            "-"
                          )}
                        </Link>
                      </td>
                      <td data-label="Supplier name">
                        <Link
                          to={`/supplierdetailsinfo?id=${d?.supplierId}`}
                          style={{ color: "rgb(13, 110, 253)" }}
                        >
                          {
                            d?.Invoice?.invoice?.Invoice
                              ?.AccountingSupplierParty?.Party?.PartyName?.Name
                              ?._text
                          }
                        </Link>
                      </td>
                      {/* <td data-label="Logs">
                        <Link onClick={(e) => onLogs(e, d?.id)}>
                          <i className="fa fa-history" aria-hidden="true"></i>
                        </Link>
                      </td> */}

                      <td data-label="Total Amount">
                        <Link to={`javascript:void(0)`}>
                          {currencyData[0]?.name} &nbsp;
                          {formatCurrency(
                            Number(
                              d?.Invoice?.invoice?.Invoice?.LegalMonetaryTotal
                                ?.PayableAmount?._text
                            ),
                            currencyData[0]?.name
                          )}
                        </Link>
                      </td>
                      <td data-label="Order Status">
                        {d?.GHG?.value && (
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip
                                id="tooltip"
                                style={{ fontSize: "12px" }}
                              >
                                {d?.GHG?.key}
                                <div>{d?.GHG?.value}</div>
                              </Tooltip>
                            }
                          >
                            <span>
                              <div>{d?.GHG?.key}</div>
                              {`${d?.GHG?.value?.slice(0, 10)}${
                                d?.GHG?.value?.length > 10 ? "..." : ""
                              }`}
                            </span>
                          </OverlayTrigger>
                        )}
                      </td>
                      <td data-label="Order Status">
                        <span className="status-chip">
                          {d?.orderStatus?.includes(",") ? (
                            d?.orderStatus
                              ?.split(",")
                              .map((item, index) => (
                                <div key={index}>
                                  {index !== 0 ? `With ${item}` : item}
                                </div>
                              ))
                          ) : (
                            <div>{d?.orderStatus}</div>
                          )}
                        </span>
                      </td>

                      <td data-label="Action">
                        <div className="flexElem">
                          <div className="me-2">
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip
                                  id="tooltip"
                                  style={{ fontSize: "12px" }}
                                >
                                  {"Registration"}
                                </Tooltip>
                              }
                            >
                              <Link onClick={(e) => onLogs(e, d?.id)}>
                                <i
                                  className="fa fa-history"
                                  aria-hidden="true"
                                ></i>
                              </Link>
                            </OverlayTrigger>

                            {/* <Link
                              onClick={(e) => onLogs(e, d?.id)}
                              title="Registrations"
                            >
                                <i
                                  className="fa fa-history"
                                  aria-hidden="true"
                                ></i>
                            </Link> */}
                          </div>
                          <div className="me-2">
                            <button
                              onClick={() => handleToggle(d?.id, d?.isActive)}
                              className="beye"
                            >
                              <i className="fa-light fa-eye"></i>
                              <i className="fa-light fa-eye-slash"></i>
                            </button>
                          </div>
                          <div>
                            <Link
                              to={`/pastorderedit?id=${d?.id}&invoiceId=${d?.invoiceId}`}
                            >
                              <i className="fa-light fa-pen"></i>
                            </Link>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {!isLoading && (
                <ReactPaginate
                  previousLabel={t("previous")}
                  nextLabel={t("next")}
                  pageCount={pagination?.totalPages}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  previousLinkClassName={"pagination__link"}
                  nextLinkClassName={"pagination__link"}
                  disabledClassName={"pagination__link--disabled"}
                  activeClassName={"pagination__link--active"}
                  forcePage={currentPage}
                />
              )}
            </div>
          </div>
        </div>

        <Modal show={showDelete} onHide={handleCloseDelete}>
          <Modal.Header closeButton>
            <Modal.Title>{t("Are you sure to delete ?")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp;
            <Button variant="primary" className="commonButton" onClick={onYes}>
              {t("Yes")}
            </Button>
            &nbsp; &nbsp; &nbsp; &nbsp;
            <Button variant="primary" className="commonButton" onClick={onNo}>
              {t("No")}
            </Button>
          </Modal.Body>
        </Modal>

        <Modal size="lg" show={showAnswer} onHide={handleCloseAnswer}>
          <Modal.Header closeButton>
            <Modal.Title>
              <h4>{t("Quality Controls Details")}</h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("Date and Time")}</th>
                    <th>{t("User")}</th>
                    <th>{t("Question")}</th>
                    <th>{t("Answer")}</th>
                  </tr>
                </thead>
                <tbody>
                  {pastOrderList[
                    anserIndex
                  ]?.SelectedPastOrderQualityControls?.map((s) => (
                    <tr className={isActive ? null : "inactive"} key={s.id}>
                      <td data-label={t("Date and Time")}>
                        {moment(s?.createdAt).format("DD-MM-YYYY, HH:mm:ss")}
                      </td>
                      <td data-label={t("User")}>
                        {s?.User.firstName} {s?.User.lastName}
                      </td>
                      <td data-label={t("Question")}>
                        {s?.QualityControl?.text}
                      </td>
                      <td
                        data-label={t("Answer")}
                        style={{
                          color: s?.answer === "Yes" ? "green" : "red",
                        }}
                      >
                        {s?.answer === "Yes" ? t("Yes") : t("No")}&nbsp;
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Modal.Body>
        </Modal>

        <Modal size="lg" show={showComment} onHide={handleCloseComment}>
          <Modal.Header closeButton>
            <Modal.Title>{t("Comments Details")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("Date and Time")}</th>
                    <th>{t("User")}</th>
                    <th>{t("Comment")}</th>
                  </tr>
                </thead>
                <tbody>
                  {pastOrderList[commentIndex]?.CommentsLogs?.map((s) => (
                    <tr className={isActive ? null : "inactive"} key={s.id}>
                      <td data-label={t("Date and Time")}>
                        {moment(s?.createdAt).format("DD-MM-YYYY, HH:mm:ss")}
                      </td>
                      <td data-label={t("User")}>
                        {s?.User.firstName} {s?.User.lastName}
                      </td>
                      <td data-label={t("Comment")}>{s?.comments}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          size="lg"
          show={logs}
          onHide={handleCloseLogs}
          dialogClassName="custom-modal-size"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h4 className="mb-3">{t("all_registrations")}</h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Nav
              fill
              variant="tabs"
              defaultActiveKey={activeTab}
              onSelect={handleSelect}
              className="navTb"
            >
              <Nav.Item>
                <Nav.Link eventKey="link-1">{t("quality_questions")}</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="link-2">{t("comments")}</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="link-3">{t("order_statuses")}</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="link-4">{t("quantity")}</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="link-5">{t("operating_units")}</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="link-6">{t("ghg_keys")}</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="link-7">{t("delivery_time")}</Nav.Link>
              </Nav.Item>
            </Nav>

            {/* QC Status */}
            {activeTab === "link-1" && (
              <div className="dbMaintable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>{t("dateAndTime")}</th>
                      <th>{t("question")}</th>
                      <th>{t("answer")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allLogs?.SelectedPastOrderQualityControls?.sort(
                      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                    )?.map((s) => (
                      <tr className={isActive ? null : "inactive"}>
                        <td data-label={t("dateAndTime")}>
                          {moment(s?.createdAt).format("DD-MM-YYYY,HH:mm:ss")}
                        </td>
                        <td data-label={t("question")}>
                          {s?.QualityControl?.text}
                        </td>
                        <td
                          data-label={t("answer")}
                          style={{
                            color: s?.answer === "Yes" ? "green" : "red",
                          }}
                        >
                          {s?.answer}&nbsp;
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* Comment Status */}
            {activeTab === "link-2" && (
              <div className="dbMaintable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>{t("dateAndTime")}</th>
                      <th>{t("user")}</th>
                      <th>{t("comment")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allLogs?.CommentsLogs?.sort(
                      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                    )?.map((s) => (
                      <tr className={isActive ? null : "inactive"}>
                        <td data-label={t("dateAndTime")}>
                          {moment(s?.createdAt).format("DD-MM-YYYY,HH:mm:ss")}
                        </td>
                        <td data-label={t("user")}>
                          {s?.User.firstName} {s?.User.lastName}
                        </td>
                        <td data-label={t("comment")}>{s?.comments}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* Order Logs */}
            {activeTab === "link-3" && (
              <div className="dbMaintable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>{t("dateAndTime")}</th>
                      <th>{t("user")}</th>
                      <th>{t("orderStatus")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allLogs?.orderStatusLogs
                      ?.sort(
                        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                      )
                      ?.map((s) => (
                        <tr className={isActive ? null : "inactive"}>
                          <td data-label={t("dateAndTime")}>
                            {moment(s?.createdAt).format("DD-MM-YYYY,HH:mm:ss")}
                          </td>
                          <td data-label={t("user")}>
                            {s?.User.firstName} {s?.User.lastName}
                          </td>
                          <td data-label={t("orderStatus")}>
                            {s?.orderStatus}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* Quantity Logs */}
            {activeTab === "link-4" && (
              <div className="dbMaintable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>{t("dateAndTime")}</th>
                      <th>{t("user")}</th>
                      <th>{t("productName")}</th>
                      <th>{t("quantity")}</th>
                      <th>{t("receivedQuantity")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allLogs?.QuantityLogs?.sort(
                      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                    )?.map((s) => (
                      <tr className={isActive ? null : "inactive"}>
                        <td data-label={t("dateAndTime")}>
                          {moment(s?.createdAt).format("DD-MM-YYYY,HH:mm:ss")}
                        </td>
                        <td data-label={t("user")}>
                          {s?.User.firstName} {s?.User.lastName}
                        </td>
                        <td data-label={t("productName")}>{s?.item}</td>
                        <td data-label={t("quantity")}>{s?.quantity}</td>
                        <td data-label={t("receivedQuantity")}>
                          {s?.receivedQuantity}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* Business Unit Logs */}
            {activeTab === "link-5" && (
              <div className="dbMaintable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>{t("dateAndTime")}</th>
                      <th>{t("user")}</th>
                      <th>{t("businessUnit")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allLogs?.businessLogs
                      ?.sort(
                        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                      )
                      ?.map((s) => (
                        <tr className={isActive ? null : "inactive"}>
                          <td data-label={t("dateAndTime")}>
                            {moment(s?.updatedAt).format("DD-MM-YYYY,HH:mm:ss")}
                          </td>
                          <td data-label={t("user")}>
                            {s?.User?.firstName} {s?.User?.lastName}
                          </td>
                          <td data-label={t("businessUnit")}>
                            {s?.BusinessUnit?.name}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* GHG Key Logs */}
            {activeTab === "link-6" && (
              <div className="dbMaintable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>{t("dateAndTime")}</th>
                      <th>{t("user")}</th>
                      <th>{t("ghgKey")}</th>
                      <th>{t("Name")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allLogs?.ghgLogs
                      ?.sort(
                        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                      )
                      ?.map((s) => (
                        <tr className={isActive ? null : "inactive"}>
                          <td data-label={t("dateAndTime")}>
                            {moment(s?.updatedAt).format("DD-MM-YYYY,HH:mm:ss")}
                          </td>
                          <td data-label={t("user")}>
                            {s?.User?.firstName} {s?.User?.lastName}
                          </td>
                          <td data-label={t("ghgKey")}>{s?.MasterGHG?.key}</td>
                          <td data-label={t("ghgKey")}>
                            {s?.MasterGHG?.value}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* Delivery Date & Time Logs */}
            {activeTab === "link-7" && (
              <div className="dbMaintable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>{t("dateAndTime")}</th>
                      <th>{t("user")}</th>
                      <th>{t("deliveryDateAndTime")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allLogs?.deliveryLogs
                      ?.sort(
                        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                      )
                      ?.map((s) => (
                        <tr className={isActive ? null : "inactive"}>
                          <td data-label={t("dateAndTime")}>
                            {moment(s?.updatedAt).format("DD-MM-YYYY,HH:mm:ss")}
                          </td>
                          <td data-label={t("user")}>
                            {s?.User?.firstName} {s?.User?.lastName}
                          </td>
                          <td data-label={t("deliveryDateAndTime")}>
                            {s?.deliveryDateTime}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )}
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default Pastorder;
